import {
  ApplicationAction,
  archiveApplicantRoute,
  declineApplicantRoute,
  hireApplicantRoute,
  saveApplicantRoute,
} from '@features/applications';

export const getTitle = (action: ApplicationAction) => {
  switch (action?.title) {
    case 'Message':
      return 'Message';
    case 'Request More Info':
      return 'More Info Request';
    case 'Move to Saved':
      return 'Save';
    case 'Invite to Interview Block':
      return 'Invite to Interview Blocks';
    case 'Invite to Open Interview':
      return 'Invite to Open Interviews';
    case 'Scheduled Interview':
      return 'Interview Invitation';
    case 'Interview Invitation':
      return 'Interview Invitation';
    case 'Send Job Offer / Hire':
      return 'Job Offer';
    case 'Move to Declined':
      return 'Decline';
    case 'Move to Archived':
      return 'Archive';
    case 'Assign Tags':
      return 'Assign Tags';
    default:
      return 'Action';
  }
};

export const getSendWithMessageButtonText = (action: ApplicationAction) => {
  switch (action?.title) {
    case 'Move to Saved':
      return 'Save & Send Message';
    case 'Invite to Interview Block':
    case 'Scheduled Interview':
    case 'Invite to Open Interview':
      return 'Invite';
    case 'Interview Invitation':
      return 'Send Invitation';
    case 'Send Job Offer / Hire':
      return 'Send Job Offers / Hire';
    case 'Move to Declined':
      return 'Decline & Send Message';
    case 'Move to Archived':
      return 'Archive & Send Message';
    default:
      return 'Send Messages';
  }
};

export const getSendWithoutMessageButtonText = (action: ApplicationAction) => {
  switch (action?.title) {
    case 'Move to Saved':
      return 'Save Without Message';
    case 'Send Job Offer / Hire':
      return 'Move to Hired w/o Message';
    case 'Move to Declined':
      return 'Decline Without Message';
    case 'Move to Archived':
      return 'Archive Without Message';
    default:
      return 'Send Without Message';
  }
};

export const getMonthName = (monthNumber: number | string) => {
  // Array of month names
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  // Return the month name (0-based index, so subtract 1 from monthNumber)
  return months[Number(monthNumber) - 1] || 'Invalid month';
};
export const getCTAButtonColor = (
  title?: string,
): 'error' | 'primary' | 'secondary' | 'success' | 'lightPurple' | 'dark' => {
  switch (title) {
    case 'Send Job Offer / Hire':
      return 'lightPurple';
    case 'Message':
    case 'Request More Info':
      return 'primary';
    case 'Invite to Interview Block':
    case 'Interview Invitation':
    case 'Invite to Open Interview':
    case 'Scheduled Interview':
      return 'secondary';
    case 'Move to Archived':
      return 'dark';
    case 'Move to Declined':
      return 'error';
    default:
      return 'success';
  }
};

export const getEndpointForApplicationAction = (action: ApplicationAction) => {
  switch (action?.actionType) {
    case 'save':
      return saveApplicantRoute;
    case 'hire':
      return hireApplicantRoute;
    case 'decline':
      return declineApplicantRoute;
    case 'archive':
      return archiveApplicantRoute;
    default:
      return '';
  }
};

export const getSuccessMessage = (
  isMessageRequired: Boolean,
  selectedAction: ApplicationAction,
) => {
  const action = selectedAction ? selectedAction.actionType : '';
  const successMessage =
    action === 'invite to interview block' ||
    action === 'Invite to Open Interview'
      ? 'Interview invite sent'
      : action === 'hire' && isMessageRequired
        ? 'Job offer sent'
        : action === 'hire' && !isMessageRequired
          ? 'Moved to hired'
          : action === 'save'
            ? 'Moved to saved'
            : action === 'Scheduled Interview'
              ? 'Interview invite sent'
              : action === 'decline'
                ? 'Moved to declined'
                : action === 'archive'
                  ? 'Moved to archived'
                  : 'Message sent';
  return successMessage;
};
